import styled from "styled-components";
import { Link } from "react-router-dom";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { mediaMax } from "components/designV2/breakpoints";
import { Duration, Easing } from "components/designV2/motion";

export const Container = styled.nav`
  align-items: center;
  background-color: ${ColorV2.White};
  border-radius: 24px;
  display: flex;
  flex: 1;
  height: 64px;
  min-width: 0;
  padding: 0 clamp(4px, 2vw, 24px);
  overflow-y: hidden;

  /* Hide the scrollbar while keeping horizontal scroll. */
  overflow-x: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* old Edge / IE */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, newer Edge */
  }
`;

export const Logo = styled.img`
  height: 64px;
  object-fit: contain;
  width: 140px;

  ${mediaMax.desktop} {
    width: 100px;
  }
`;

export const Items = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: clamp(16px, 4vw, 64px);
  justify-content: flex-end;

  ${mediaMax.desktop} {
    justify-content: flex-start;
    gap: 20px;
    margin-left: 16px;
  }
`;

export const IconWrap = styled.span`
  display: inline-flex;
  position: relative;
`;

export const Label = styled.span<{ $isActive: boolean }>`
  ${TypographyV2.b1}
  color: inherit;
  max-width: ${(props) => (props.$isActive ? "180px" : "0")};
  opacity: ${(props) => (props.$isActive ? 1 : 0)};
  overflow: hidden;
  transform: ${(props) =>
    props.$isActive ? "translateX(0)" : "translateX(-6px)"};
  transition:
    max-width ${Duration.standard} ${Easing.standard},
    opacity ${Duration.standard} ${Easing.standard},
    transform ${Duration.standard} ${Easing.standard};
  white-space: nowrap;
`;

export const ItemLink = styled(Link)<{ $isActive: boolean }>`
  ${TypographyV2.b1}
  align-items: center;
  color: ${(props) => (props.$isActive ? ColorV2.Blue1 : ColorV2.Blue5)};
  display: inline-flex;
  gap: ${(props) => (props.$isActive ? "12px" : "0")};
  text-decoration: none;
  transition:
    gap ${Duration.standard} ${Easing.standard},
    color ${Duration.standard} ${Easing.standard};

  &:hover {
    color: ${ColorV2.Blue3};
    gap: 12px;

    ${Label} {
      max-width: 180px;
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
